import React from "react";
import Color from "color";
import Format from "../../Format";
import Icon from "../../Icon/Icon";
import { createLink } from "../../../utils";
import { useGlobalValue } from "../../../state/GlobalProvider";
import { Link } from "../..";
import styles from "./TotalCard.module.sass";
const TotalCard = props => {
  const {
    value: v,
    label: l,
    icon: ico,
    backgroundColor: bg,
    color: c,
    data = {}
  } = props;
  const {
    proxy,
    params
  } = useGlobalValue();
  const value = v || data.value;
  const label = l || data.label;
  const icon = ico || data.icon;
  const backgroundColor = bg || data.backgroundColor;
  const color = c || data.color;
  const titleStyle = color ? {
    color
  } : null;
  const subtitleStyle = color ? {
    color,
    opacity: 0.8
  } : null;
  const bgStyle = backgroundColor ? {
    backgroundImage: `linear-gradient(35deg, ${backgroundColor}, ${new Color(backgroundColor).rotate(-10).hex()})`
  } : null;
  const path = createLink(null, proxy, data, params);
  return /*#__PURE__*/React.createElement("div", {
    className: styles["root"]
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["background"],
    style: bgStyle
  }), /*#__PURE__*/React.createElement("div", {
    className: styles["icon-container"]
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    className: styles["icon"],
    name: icon
  })), /*#__PURE__*/React.createElement("div", {
    className: styles["details"]
  }, /*#__PURE__*/React.createElement("h3", {
    className: styles["title"],
    style: titleStyle
  }, value ? /*#__PURE__*/React.createElement(Format, {
    value: value,
    compact: "short"
  }) : ` -- `), path && /*#__PURE__*/React.createElement(Link, {
    to: path,
    className: styles["label"],
    style: subtitleStyle,
    label: label
  }), !path && /*#__PURE__*/React.createElement("small", {
    className: styles["label"],
    style: subtitleStyle
  }, label)));
};
export default TotalCard;